import DefaultPage from "grandus-lib/pages/cart/step1.default";

export default DefaultPage;
